(function () {
    'use strict';

    window.addEventListener('DOMContentLoaded',  () => {
        const bttns = document.querySelectorAll('.qld__widgets .qld__btn--back-to-top');

        bttns.forEach( (box) => {
            box.addEventListener('click', (event) => { 
                window.scrollTo({
                    top:        0,
                    behavior:   'smooth'
                });

                const header = document.querySelector('.qld__skip-link');

                header?.focus();
                header?.blur();
            });
        });

        document.addEventListener('scroll', (event) => {
            const cssClass = 'qld__btn--show',
                root = document.documentElement,
                total = root.scrollHeight - root.clientHeight;
    
            if ((root.scrollTop / total ) < 0.1 ) {
                bttns.forEach( bttn => bttn.classList.remove(cssClass) );
            } else {
                bttns.forEach( bttn => bttn.classList.add(cssClass) );
            }
    
        });
    });
}());